import { Component } from '@angular/core';
import { SidenavService } from '../services/sidenav.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    standalone: true
})
export class ContactComponent {
  constructor(private sidenavService: SidenavService) {
    this.sidenavService.close();
  }
}
